import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * NotFoundPage component displayed when a route doesn't exist
 * @returns {JSX.Element} NotFoundPage component
 */
const NotFoundPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="not-found-container" style={{ 
      textAlign: 'center', 
      padding: '50px 20px',
      maxWidth: '600px',
      margin: '0 auto' 
    }}>
      <h1>Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <button 
        onClick={() => navigate('/')}
        style={{
          padding: '10px 20px',
          background: '#1976D2',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        Return to Home
      </button>
    </div>
  );
};

export default NotFoundPage;
